// Local translations
export const T = {
  en_GB: {
    title: "You are signed in to another organization",
    signedInTo: (current: string, target: string) =>
      `You are signed in to ${current}, but this page belongs to ${target}.`,
    targetMissing: (current: string, target: string) =>
      `You are signed in to ${current}. The organization “${target}” does not exist.`,
    lookupFailed: (current: string, target: string) =>
      `You are signed in to ${current}. We could not check the organization “${target}” right now.`,
    oneAtATime: "You can only be signed in to one organization at a time.",
    signOutAndContinue: "Sign out and continue",
    goTo: "Go to my organization",
    continueWith: (current: string) => `Continue with ${current}`,
    retry: "Try again",
  },
  nb_NO: {
    title: "Du er logget inn i en annen organisasjon",
    signedInTo: (current: string, target: string) =>
      `Du er logget inn i ${current}, men denne siden tilhører ${target}.`,
    targetMissing: (current: string, target: string) =>
      `Du er logget inn i ${current}. Organisasjonen «${target}» finnes ikke.`,
    lookupFailed: (current: string, target: string) =>
      `Du er logget inn i ${current}. Vi kunne ikke sjekke organisasjonen «${target}» akkurat nå.`,
    oneAtATime: "Du kan bare være logget inn i én organisasjon om gangen.",
    signOutAndContinue: "Logg ut og fortsett",
    goTo: "Gå til min organisasjon",
    continueWith: (current: string) => `Fortsett med ${current}`,
    retry: "Prøv igjen",
  },
} as const;
